// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.task-date-picker .custom-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 8px;
}
.task-date-picker .custom-header-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #9c9c9c;
}
.task-date-picker .custom-header-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.task-date-picker .month-year {
  font-weight: 600;
  font-size: 1.2rem;
  color: #696969;
}
.task-date-picker .custom-datepicker-nav {
  color: inherit;
}
.task-date-picker .date-picker-wrapper {
  justify-content: center;
}
.task-date-picker .date-picker-wrapper .react-datepicker {
  border: none;
  border-bottom: 1px solid #efefef;
  padding-bottom: 13px;
  width: 100%;
}
.task-date-picker .date-picker-wrapper .react-datepicker__header {
  text-transform: none;
  border-bottom: none;
  width: 98%;
  font-family: "Raleway", sans-serif;
  margin-left: 0;
}
.task-date-picker .date-picker-wrapper .react-datepicker__month-container {
  float: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.task-date-picker .date-picker-wrapper .react-datepicker__month {
  font-family: "Raleway", sans-serif;
  width: 100%;
}
.task-date-picker .date-picker-wrapper .react-datepicker__navigation {
  font-size: 15px;
  height: 14px;
  width: 14px;
}
.task-date-picker .date-picker-wrapper .react-datepicker__current-month {
  font-weight: 300;
}
.task-date-picker .date-picker-wrapper .react-datepicker__week {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day {
  font-size: 12px;
  margin: 0.8rem 0px;
  color: #696969;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day--today {
  color: white;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day--today::before {
  background-color: var(--default-calendar-color, #515554) !important;
  height: 2.8rem;
  width: 2.8rem;
  top: -5px;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day:hover {
  color: white;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day:hover::before {
  color: white;
  height: 2.8rem;
  width: 2.8rem;
  top: -5px;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day--highlighted::after {
  background-color: transparent;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day--selected {
  color: white;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day--selected::before {
  content: "";
  position: absolute;
  background-color: #515554;
  border-radius: 50%;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  height: 2.8rem;
  width: 2.8rem;
  z-index: -2;
  text-align: center;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day--outside-month {
  visibility: hidden;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day-names {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}
.task-date-picker .date-picker-wrapper .react-datepicker__day-name {
  font-size: 16px;
  color: #696969;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/ChecklistsDisplay/TaskDatePicker.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;AACJ;AAEE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cDEQ;ACFZ;AAEI;EACE,YAAA;EACA,mBAAA;AAAN;AAIE;EACE,gBAAA;EACA,iBAAA;EACA,cDzBY;ACuBhB;AAKE;EACE,cAAA;AAHJ;AAME;EACE,uBAAA;AAJJ;AAKI;EACE,YAAA;EACA,gCAAA;EACA,oBAAA;EACA,WAAA;AAHN;AAIM;EACE,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,kCAAA;EACA,cAAA;AAFR;AAIM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFR;AAIM;EACE,kCAAA;EACA,WAAA;AAFR;AAIM;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAFR;AAIM;EACE,gBAAA;AAFR;AAIM;EACE,aAAA;EACA,6BAAA;EACA,WAAA;AAFR;AAIM;EACE,eAAA;EACA,kBAAA;EACA,cDxEQ;ACsEhB;AAGQ;EACE,YAAA;AADV;AAEU;EACE,mEAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAAZ;AAGQ;EACE,YAAA;AADV;AAEU;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAAZ;AAIU;EACE,6BAAA;AAFZ;AAKQ;EACE,YAAA;AAHV;AAIU;EACE,WAAA;EACA,kBAAA;EACA,yBD7FD;EC8FC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAFZ;AAMM;EACE,kBAAA;AAJR;AAMM;EACE,aAAA;EACA,6BAAA;EACA,WAAA;AAJR;AAMM;EACE,eAAA;EACA,cD3HQ;EC4HR,gBAAA;AAJR","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.task-date-picker {\n  .custom-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n    gap: 8px;\n  }\n\n  .custom-header-button {\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    color: $iconColor;\n\n    &:disabled {\n      opacity: 0.3;\n      cursor: not-allowed;\n    }\n  }\n\n  .month-year {\n    font-weight: 600;\n    font-size: 1.2rem;\n    color: $darkTextColor;\n  }\n\n  .custom-datepicker-nav {\n    color: inherit;\n  }\n\n  .date-picker-wrapper {\n    justify-content: center;\n    .react-datepicker {\n      border: none;\n      border-bottom: 1px solid $gray;\n      padding-bottom: 13px;\n      width: 100%;\n      &__header {\n        text-transform: none;\n        border-bottom: none;\n        width: 98%;\n        font-family: 'Raleway', sans-serif;\n        margin-left: 0;\n      }\n      &__month-container {\n        float: unset;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n      }\n      &__month {\n        font-family: 'Raleway', sans-serif;\n        width: 100%;\n      }\n      &__navigation {\n        font-size: 15px;\n        height: 14px;\n        width: 14px;\n      }\n      &__current-month {\n        font-weight: 300;\n      }\n      &__week {\n        display: flex;\n        justify-content: space-evenly;\n        width: 100%;\n      }\n      &__day {\n        font-size: 12px;\n        margin: 0.8rem 0px;\n        color: $darkTextColor;\n        &--today {\n          color: white;\n          &::before {\n            background-color: var(--default-calendar-color, $darkGray) !important;\n            height: 2.8rem;\n            width: 2.8rem;\n            top: -5px;\n          }\n        }\n        &:hover {\n          color: white;\n          &::before {\n            color: white;\n            height: 2.8rem;\n            width: 2.8rem;\n            top: -5px;\n          }\n        }\n        &--highlighted {\n          &::after {\n            background-color: transparent;\n          }\n        }\n        &--selected {\n          color: white;\n          &::before {\n            content: '';\n            position: absolute;\n            background-color: $darkGray;\n            border-radius: 50%;\n            top: -5px;\n            left: 50%;\n            transform: translateX(-50%);\n            height: 2.8rem;\n            width: 2.8rem;\n            z-index: -2;\n            text-align: center;\n          }\n        }\n      }\n      &__day--outside-month {\n        visibility: hidden;\n      }\n      &__day-names {\n        display: flex;\n        justify-content: space-evenly;\n        width: 100%;\n      }\n      &__day-name {\n        font-size: 16px;\n        color: $darkTextColor;\n        font-weight: 400;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
